import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'
import SectionQuote from './SectionQuote'
import { ArrowRightCircle } from 'react-feather'

export const FormStepApplication = ({useFetchInit}) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions
  } = useFetchInit



  // ------------------------------------------------ Acciones

  const {handleClickNextStep} = Actions
  // ------------------------------------------------ globalStates
  const { stepApplilication, formOpeningMode } = globalStates

  // ------------------------------------------------ Formularios
  const { FormRequestGlobal } = Forms
  const { formState, onInputChange, onSelectSearchChange } = FormRequestGlobal

  // ------------------------------------------------ FetchData
  const { fetchAllCustomers, fetchAllVehicles, fetchAllQuotes } = FetchData
  const { vehicles } = fetchAllVehicles
  const { customers } = fetchAllCustomers
  const { quotes } = fetchAllQuotes

  return (
    <form>
        <Typography sx={{mt:3, fontWeight: 'bold'}} variant='subtitle2'>
          Datos Generales
        </Typography>
        <div className="border-bottom border-dark"></div>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth>
              <label htmlFor="credito_fecha">* Fecha de Registro</label>
                <TextField
                    id='credito_fecha'
                    name='credito_fecha'
                    value={ formState.credito_fecha }
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Día de registro'
                    type='date'
                    variant={'filled'}
                    InputProps={{readOnly: true}}
                    required
                />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth>
              <label htmlFor="credito_dia_pago">* Fecha de Pago</label>
                <TextField
                    id='credito_dia_pago'
                    name='credito_dia_pago'
                    value={ formState.credito_dia_pago }
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Día de pago'
                    type='date'
                    variant={'filled'}
                    InputProps={{readOnly: true}}
                    required
                />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth>
              <label htmlFor="idcliente">* Cliente</label>
              <CustomAutocomplete 
                  customId="idcliente"
                  customName="idcliente"
                  customValue={formState.idcliente}
                  customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcliente', value: value.value }  })}
                  customPlaceholder='Seleccionar cliente'
                  customOptions={
                      customers.map(({ idcliente, dpi, nombre }) => ({
                          value: idcliente,
                          name: `${dpi} - ${nombre}`
                      }))
                  }
                  customDisableClearable={true}
                  customDisabled={true}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth>
              <label htmlFor="idcotizacion">* Cotizacion</label>
              <CustomAutocomplete 
                  customId="idcotizacion"
                  customName="idcotizacion"
                  customValue={formState.idcotizacion}
                  customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcotizacion', value: value.value }  })}
                  customPlaceholder='Seleccionar una cotizacion'
                  customOptions={
                      quotes.map(({ idcotizacion, numero_cotizacion, nombre_cliente}) => ({
                          value: idcotizacion,
                          name: `${numero_cotizacion} - ${nombre_cliente}`
                      }))
                  }
                  customDisableClearable={true}
                  customDisabled={true}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth>
              <label htmlFor="idvehiculo">* Vehiculo</label>
              <CustomAutocomplete 
                  customId="idvehiculo"
                  customName="idvehiculo"
                  customValue={formState.idvehiculo}
                  customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idvehiculo', value: value.value }  })}
                  customPlaceholder='Seleccione un vehiculo'
                  customOptions={
                      vehicles.map(({ idvehicle, marca, modelo, linea, matricula  }) => ({
                          value: idvehicle,
                          name: `${marca} - ${linea}, Año: ${modelo}, Matricula: ${matricula}`
                      }))
                  }
                  customDisableClearable={true}
                  customDisabled={true}
              />
            </FormControl>
          </Grid>
        </Grid>

        {(formState.idcotizacion>0) && (
          <SectionQuote 
            FormRequestGlobal = {FormRequestGlobal}
          />
        )}

        <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
          <Grid item xs={12}>
            <div className="text-center">
                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="button"
                    className='btn-round'
                    color='primary'
                    onClick={handleClickNextStep}
                    sx={{ mr: 2, ml: 2, mt: 3 }}
                >
                  Continuar
                </Button>
            </div>
          </Grid>
        </Grid>

    </form>

  )
}

